export default __webpack_public_path__ + "static/media/Gene-engineered Haematopoeric stem cells.5f1d0374.pdf";